import { Sms, User, Eye, EyeSlash } from "iconsax-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import instance, { url } from "../../../axios/instance";
import { Oval } from "react-loader-spinner";
import Color from "color";

export default function RequestVitalRxAccountPage() {
    const navigate = useNavigate();
    const location = useLocation();


    const pharmacyId = location.search.split("?id=")[1];
    console.log("VitalRx Request Page - Full URL:", location.pathname + location.search);
    console.log("VitalRx Request Page - Search params:", location.search);
    console.log("VitalRx Request Page - Pharmacy ID:", pharmacyId);
    const [pharmacy, setPharmacy] = useState(null);
    const [pharmLoading, setPharmLoading] = useState(true);

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        facilityType: "clinic",
        email: "",
        workPhone: "",
        clinicName: "",
        address: ""
    });
    const [selectedServices, setSelectedServices] = useState([]);
    const [otherService, setOtherService] = useState("");
    const [requestNotes, setRequestNotes] = useState("");
    const [selectedOther, setSelectedOther] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [success, setSuccess] = useState(false);

    const facilityTypes = [
        { account_type: "clinic", name: "clinic" },
        { account_type: "clinic", name: "hospital" },
        { account_type: "distributor", name: "distributor" },
        { account_type: "distributor", name: "pharmacy" },
    ];

    const services = [
        "Sterile compounding",
        "Non-sterile compounding",
        "Medication dispensing",
        "Medical supplies",
        "Other",
    ];

    const isButtonActive =
        formData.firstName &&
        formData.lastName &&
        formData.email &&
        formData.workPhone &&
        formData.clinicName &&
        formData.address &&
        formData.facilityType;

    async function getPharmacyInfo() {
        instance
            .post("/pharmacy/get_by_id", {
                id: pharmacyId,
            })
            .then((response) => {
                console.log(response.data);
                setPharmacy(response.data);
                setPharmLoading(false);
            })
            .catch((error) => {
                console.log(error.response.data);
                setPharmacy(null);
                setPharmLoading(false);
            });
    }

    const handleServiceToggle = (service) => {
        setSelectedServices((prev) =>
            prev.includes(service)
                ? prev.filter((s) => s !== service)
                : [...prev, service]
        );
    };

    // test effect
    const [logo, setLogo] = useState(null);

    useEffect(() => {
        const testLogo = window.localStorage.getItem("PHARM_LOGO");
        if (!testLogo) {
            console.log("There is no logo use default");
            setLogo("/clinic/images/vitalrx-logo.png");
        } else {
            console.log("there is logo");
            setLogo("/clinic/images/vitalrx-logo.png");
        }

        getPharmacyInfo();
    }, []);

    useEffect(() => {
        if (selectedServices.includes("Other")) {
            setSelectedOther(true);
        } else {
            setSelectedOther(false);
        }
    }, [selectedServices]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");

        try {
            const response = await instance.post("/doctor/facility/new", {
                contactName: `${formData.firstName} ${formData.lastName}`,
                email: formData.email,
                homePhone: formData.workPhone,
                address: formData.address,
                name: formData.clinicName,
                pharmacy_id: pharmacy.id,
                type: facilityTypes
                    .find(
                        (type) => type.name.toLowerCase() === formData.facilityType.toLowerCase()
                    )
                    .account_type.toLowerCase(),
                facilityType: formData.facilityType.toLowerCase(),
                services: otherService
                    ? [
                        ...selectedServices.filter((service) => service !== "Other"),
                        otherService,
                    ]
                    : selectedServices,
                notes: requestNotes,
            });

            console.log(response.data);
            setLoading(false);
            navigate("/auth/request-success");
        } catch (error) {
            setLoading(false);
            setErrorMessage(error.response.data.message);
            console.log(error.response.data);
        }
    };

    if (pharmLoading) {
        return (
            <div className="h-[100svh] flex justify-center items-center">
                <Oval
                    color="#007b7d"
                    secondaryColor="rgba(0,123,125,0.2)"
                    strokeWidth={4}
                    width={24}
                    height={24}
                />
            </div>
        );
    }

    if (!location.search || !pharmacyId || !pharmacy) {
        return <div>Invalid pharmacy URL, contact pharmacy</div>;
    }

    return (
        <div className="min-h-screen flex">
            {/* Left Section - Request Account Form */}
            <div className="flex-1 bg-white flex flex-col px-8 lg:px-16 xl:px-24">
                <div className="max-w-md mx-auto w-full py-8 flex flex-col justify-center min-h-screen">
                    {/* Logo */}
                    <div className="mb-8">
                        <img src="/clinic/images/vitalrx-logo.png" className="w-32 h-auto" alt="Pharmacy logo" />
                    </div>

                    {/* Main Content */}
                    {success ? (
                        <div className="text-gray-600 text-center">
                            <div className="text-lg font-medium mb-2">Request Submitted</div>
                            <div className="text-sm mb-6">
                                Thank you for your interest! We'll review your request and get back to you soon.
                            </div>
                            <Link
                                to="/auth/login"
                                className="inline-block bg-[#007b7d] text-white py-3 px-6 rounded-lg font-medium hover:bg-[#005a5c] transition-colors"
                            >
                                Back to Login
                            </Link>
                        </div>
                    ) : (
                        <>
                            <div className="mb-8">
                                <h1 className="text-2xl font-bold text-gray-900 mb-2">
                                    Request a new account
                                </h1>
                                <p className="text-gray-600 text-sm">
                                    Fill in your credentials to request an account from pharmacy.
                                </p>
                            </div>

                            {/* Request Account Form */}
                            <div className="px-2 max-h-[60vh] overflow-y-auto scrollbar-hide">
                                <form onSubmit={handleSubmit} className="space-y-4">
                                    {/* Pharmacy Information */}
                                    {/* <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                        <div className="text-sm font-medium text-gray-700 mb-2">Pharmacy name</div>
                                        <div className="text-gray-600">{pharmacy.pharmacy_name}</div>
                                    </div> */}
                                    {/* Personal Name - First and Last Name */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Personal name
                                        </label>
                                        <div className="grid grid-cols-2 gap-3">
                                            <input
                                                type="text"
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleInputChange}
                                                placeholder="Firstname"
                                                className="block w-full px-3 py-3 border border-gray-300 text-[14px] rounded-lg focus:ring-2 focus:ring-[#007b7d] focus:border-transparent outline-none transition-colors"
                                                required
                                            />
                                            <input
                                                type="text"
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleInputChange}
                                                placeholder="Lastname"
                                                className="block w-full px-3 py-3 border border-gray-300 text-[14px] rounded-lg focus:ring-2 focus:ring-[#007b7d] focus:border-transparent outline-none transition-colors"
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Facility Type */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Facility type
                                        </label>
                                        <div className="relative">
                                            <select
                                                name="facilityType"
                                                value={formData.facilityType}
                                                onChange={handleInputChange}
                                                className="block w-full px-3 py-3 border border-gray-300 text-[14px] rounded-lg focus:ring-2 focus:ring-[#007b7d] focus:border-transparent outline-none transition-colors appearance-none bg-white"
                                            >
                                                {facilityTypes.map((type, index) => (
                                                    <option value={type.name} key={index}>
                                                        {type.name}
                                                    </option>
                                                ))}
                                            </select>
                                            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Email Address */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Email address
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            placeholder="name@email.com"
                                            className="block w-full px-3 py-3 border border-gray-300 text-[14px] rounded-lg focus:ring-2 focus:ring-[#007b7d] focus:border-transparent outline-none transition-colors"
                                            required
                                        />
                                    </div>

                                    {/* Work Phone */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Work phone
                                        </label>
                                        <input
                                            type="tel"
                                            name="workPhone"
                                            value={formData.workPhone}
                                            onChange={handleInputChange}
                                            placeholder="+1 (234) 5690"
                                            className="block w-full px-3 py-3 border border-gray-300 text-[14px] rounded-lg focus:ring-2 focus:ring-[#007b7d] focus:border-transparent outline-none transition-colors"
                                        />
                                    </div>

                                    {/* Clinic Name */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Clinic name
                                        </label>
                                        <input
                                            type="text"
                                            name="clinicName"
                                            value={formData.clinicName}
                                            onChange={handleInputChange}
                                            placeholder="Clinic name"
                                            className="block w-full px-3 py-3 border border-gray-300 text-[14px] rounded-lg focus:ring-2 focus:ring-[#007b7d] focus:border-transparent outline-none transition-colors"
                                            required
                                        />
                                    </div>

                                    {/* Address */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Address
                                        </label>
                                        <input
                                            type="text"
                                            name="address"
                                            value={formData.address}
                                            onChange={handleInputChange}
                                            placeholder="Address"
                                            className="block w-full px-3 py-3 border border-gray-300 text-[14px] rounded-lg focus:ring-2 focus:ring-[#007b7d] focus:border-transparent outline-none transition-colors"
                                        />
                                    </div>

                                    {/* Pharmacy Services */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Pharmacy services requested <span className="text-red-500">*</span>
                                        </label>
                                        {services.map((service, index) => (
                                            <label key={index} className="flex items-center my-2">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedServices.includes(service)}
                                                    onChange={() => handleServiceToggle(service)}
                                                    className="h-4 w-4 text-[#007b7d] focus:ring-[#007b7d] border-gray-300 rounded"
                                                />
                                                <span className="ml-2 text-gray-700 text-sm">{service}</span>
                                            </label>
                                        ))}
                                        <div className="text-xs text-gray-500">Select all that apply</div>
                                    </div>

                                    {/* Other Service Input */}
                                    {selectedOther && (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Please specify the services you are requesting
                                            </label>
                                            <input
                                                type="text"
                                                value={otherService}
                                                onChange={(e) => setOtherService(e.target.value)}
                                                placeholder="Please specify"
                                                className="block w-full px-3 py-3 border border-gray-300 text-[14px] rounded-lg focus:ring-2 focus:ring-[#007b7d] focus:border-transparent outline-none transition-colors"
                                            />
                                        </div>
                                    )}

                                    {/* Additional Notes */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Additional notes or Special requests
                                        </label>
                                        <textarea
                                            value={requestNotes}
                                            onChange={(e) => setRequestNotes(e.target.value)}
                                            className="block w-full px-3 py-3 border border-gray-300 text-[14px] rounded-lg focus:ring-2 focus:ring-[#007b7d] focus:border-transparent outline-none transition-colors resize-none"
                                            rows={4}
                                            maxLength={500}
                                            placeholder="Any additional information or special requests..."
                                        />
                                    </div>

                                    {/* Error Message */}
                                    {errorMessage && (
                                        <div className="text-red-500 text-sm font-medium">
                                            {errorMessage}
                                        </div>
                                    )}

                                    {/* Submit Button */}
                                    <button
                                        type="submit"
                                        disabled={!isButtonActive || loading}
                                        style={{
                                            backgroundColor: !isButtonActive
                                                ? Color(pharmacy?.theme_color || "#007b7d").alpha(0.2)
                                                : pharmacy?.theme_color || "#007b7d",
                                            color: !isButtonActive ? pharmacy?.theme_color || "#007b7d" : "#fff",
                                        }}
                                        className={`w-full ${!isButtonActive ? "cursor-not-allowed" : ""
                                            } py-3 px-4 rounded-lg font-medium focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors`}
                                    >
                                        {loading ? "Requesting..." : "Request account"}
                                    </button>

                                    {/* Links */}
                                    <div className="mt-6 space-y-3 text-center">
                                        <div className="text-sm text-gray-600">
                                            Already have an account?{" "}
                                            <Link
                                                to="/auth/extras/vitalRx/login"
                                                className="font-medium text-gray-900 hover:text-gray-700"
                                            >
                                                Sign in
                                            </Link>
                                        </div>

                                        {/* <div className="font-regular text-[13px] text-center">
                                            By signing up you agree to BlendcareRx's{" "}
                                            <span className="text-primary">Terms of Uses</span>,{" "}
                                            <span className="text-primary">Privacy Policy</span>,{" "}
                                            <span className="text-primary">
                                                HIPAA Policy, Delivery Policy
                                            </span>
                                            , and{" "}
                                            <span className="text-primary">
                                                HIPAA marketing authorization
                                            </span>
                                        </div> */}
                                    </div>

                                    {/* Information Section */}
                                    <div className="mt-8 p-4 bg-gray-50 rounded-lg">
                                        <div
                                            style={{ color: pharmacy?.theme_color || "#007b7d" }}
                                            className="font-bold text-[15px] mb-1"
                                        >
                                            Join Our Provider Network
                                        </div>

                                        <div className="font-regular text-[14px] text-gray-500">

                                            Sign up your medical clinic to become a {pharmacy?.pharmacy_name} Pharmacy provider and start sending prescriptions for mail delivery or pickup at one of our partner locations.
                                            Once approved, you'll receive login access to our BlendCareRx CareApps portal, where you can securely submit prescriptions on behalf of your patients.
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* Right Section - Background Image */}
            <div style={{ backgroundImage: "url('/clinic/images/authimg2.jpg')" }} className="hidden lg:flex lg:flex-1 relative bg-center bg-cover bg-no-repeat">
                <div className="absolute inset-0 bg-gradient-to-br from-[#007b7d]/70 via-[#005a5c]/60 to-black/80">
                    {/* Abstract shapes overlay */}
                    <div className="absolute inset-0">
                        <div className="absolute top-20 left-10 w-32 h-32 bg-[#007b7d]/20 rounded-full blur-xl"></div>
                        <div className="absolute top-40 right-20 w-24 h-24 bg-[#007b7d]/15 rounded-full blur-xl"></div>
                        <div className="absolute bottom-40 left-20 w-40 h-40 bg-[#005a5c]/25 rounded-full blur-xl"></div>
                        <div className="absolute bottom-20 right-10 w-28 h-28 bg-[#007b7d]/10 rounded-full blur-xl"></div>
                    </div>

                    {/* Mountain silhouette */}
                    <div className="absolute bottom-0 right-0 w-full h-32">
                        <svg viewBox="0 0 400 100" className="w-full h-full">
                            <path d="M0,100 L50,60 L100,80 L150,40 L200,70 L250,30 L300,50 L350,20 L400,40 L400,100 Z"
                                fill="rgba(0,123,125,0.4)" />
                        </svg>
                    </div>


                </div>
            </div>
            {/* Powered by */}
            <div className="absolute bottom-4 left-4 flex items-center gap-2 text-[#111111] text-xs">
                <span>Powered by</span>
                <img src="/clinic/images/logo-bw.png" className="w-24 h-auto" alt="BCRX" />
            </div>
        </div>
    );
}
